import React from 'react';
import {
  IMAGE_ASPECT_COVER,
  IMAGE_UNAVAILABLE_IMAGE_URL,
  PRODUCT_STYLE_LIST,
} from '../../../../../../../constants';
import styles from '../../../Product.styles';
import { isStringNotNull } from '../../../../../../../utils';
import { useAppSelector } from '../../../../../../../redux/hook';

type ProductImageProps = {
  image: any;
  title: string;
};

export default function ProductImage({ image, title }: ProductImageProps) {
  const { productStyle, images } = useAppSelector(
    (state) => state.configurationReducer
  );

  const { isHorizontalSection } = useAppSelector(
    (state) => state.componentReducer
  );
  const imageProductGridClass = isHorizontalSection
    ? 'image-product-grid-horizontal'
    : 'image-product-grid-vertical';
  const imageProductListClass = isHorizontalSection
    ? 'image-product-list-horizontal'
    : 'image-product-list-vertical';
  const imageUrl = !isStringNotNull(image)
    ? IMAGE_UNAVAILABLE_IMAGE_URL
    : image;
  const { aspect } = images;
  const objectFitStyle = aspect === IMAGE_ASPECT_COVER ? !isStringNotNull(image) ? 'cover' : 'fill' : 'contain'
  if (productStyle === PRODUCT_STYLE_LIST) {
    const imageProductClassname = `col-5 img-fluid float-left ${imageProductListClass} `;
    return (
      <img
        src={imageUrl}
        alt={title}
        className={imageProductClassname}
         style={{
             ...styles.productPictureBorder,
            objectFit: objectFitStyle
         }}
      />
    );
  }
  const imageProductClassname = `img-fluid col-12 ${imageProductGridClass}`;
  return (
    <img
      src={imageUrl}
      alt={title}
      className={imageProductClassname}
       style={{
             ...styles.productPicture,
            objectFit: objectFitStyle
         }}
    />
  );
}
